module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "shop-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("StumpTheSpread Shop")]), _vm._v(" "), _c('div', {
    staticClass: "picks-notice"
  }, [_c('p', [_vm._v("Looking to purchase picks? "), _c('router-link', {
    attrs: {
      "to": "/buy"
    }
  }, [_vm._v("Click here to Buy Premium Picks!")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading products...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : (_vm.products.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("No products available at the moment.")])]) : _c('div', {
    staticClass: "product-grid"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "product-card",
      on: {
        "click": function($event) {
          _vm.viewProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "product-image"
    }, [(product.is_on_sale) ? _c('div', {
      staticClass: "sale-badge"
    }, [_vm._v("SALE")]) : _vm._e(), _vm._v(" "), (_vm.primaryImage(product)) ? _c('img', {
      attrs: {
        "src": _vm.primaryImage(product).image_url,
        "alt": product.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("No Image")])]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('h3', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('p', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(_vm.truncateDescription(product.description)))]), _vm._v(" "), _c('div', {
      staticClass: "product-footer"
    }, [_c('div', {
      staticClass: "price-container"
    }, [(product.is_on_sale) ? _c('span', {
      staticClass: "product-price-regular"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(product.base_price_cents)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "product-price",
      class: {
        'product-price-sale': product.is_on_sale
      }
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(product.is_on_sale ? product.sale_price_cents : product.base_price_cents)) + "\n                ")]), _vm._v(" "), (product.is_on_sale && product.discount_percentage) ? _c('span', {
      staticClass: "discount-badge"
    }, [_vm._v("\n                  -" + _vm._s(product.discount_percentage) + "%\n                ")]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn-view"
    }, [_vm._v("View Details")])])])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a1daae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shop.vue
// module id = 289
// module chunks = 1